// client/src/hooks/useSortableData.js
import { useMemo, useState } from "react";

export const useSortableData = (items, initialSortConfig = null) => {
    const [sortConfig, setSortConfig] = useState(initialSortConfig);

    const sortedItems = useMemo(() => {
        if (!items) return [];
        let sortableItems = [...items];
        if (sortConfig?.key) {
        sortableItems.sort((a, b) => {
            const aVal = a[sortConfig.key] ?? "";
            const bVal = b[sortConfig.key] ?? "";

            // Comparar strings numéricos si es posible
            const aNum = parseFloat(aVal);
            const bNum = parseFloat(bVal);
            if (!isNaN(aNum) && !isNaN(bNum)) {
            return sortConfig.direction === "asc" ? aNum - bNum : bNum - aNum;
            }

            // Comparación general de strings
            if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
            if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
            return 0;
        });
        }
        return sortableItems;
    }, [items, sortConfig]);

    return { sortedItems, sortConfig, setSortConfig };
};
